export class Issue {
    title: string;
    body: string;
}